import {
  EmptyEnrollmentApplication,
  EnrollmentApplication,
  SavingEnrollmentApplication,
  ValidEnrollmentApplication,
  EnrollmentApplicationWithError,
  EnrollmentApplicationWithDuplicateUploadError
} from 'Agent/Accounts/models/A360EnrollmentApplication';
import {Async, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';

export enum A360EnrollmentApplicationActionType {
  CUSTOMER_CONNECTION_PROFILE = 'a360EnrollmentApplication/CUSTOMER_CONNECTION_PROFILE',
  CHANGE_CUSTOMER_CONNECTION_PROFILE = 'a360EnrollmentApplication/CHANGE_CUSTOMER_CONNECTION_PROFILE',
  UPLOAD_APPLICATION = 'a360EnrollmentApplication/UPLOAD_APPLICATION',
  CHANGE_ENROLLMENT_FILE = 'a360EnrollmentApplication/CHANGE_ENROLLMENT_FILE',
  SHOW_ERROR = 'a360EnrollmentApplication/SHOW_ERROR',
  SHOW_DUPLICATE_UPLOAD_ERROR = 'a360EnrollmentApplication/SHOW_DUPLICATE_UPLOAD_ERROR',
  CLEAR_APPLICATION = 'a360EnrollmentApplication/CLEAR_APPLICATION',
}

export const getCustomerConnectionProfile = (customerUri: string, accountNumber: string, accountName: string) => 
  createAction(A360EnrollmentApplicationActionType.CUSTOMER_CONNECTION_PROFILE, {customerUri, accountNumber, accountName});

export const changeCustomerConnectionProfile = (custConProfile: Async<CustomerConnectionProfile[]>) => 
  createAction(A360EnrollmentApplicationActionType.CHANGE_CUSTOMER_CONNECTION_PROFILE, {custConProfile});

export const showError = (application: ValidEnrollmentApplication) =>
  createAction(A360EnrollmentApplicationActionType.SHOW_ERROR, {application});

export const showDuplicateUploadError = (application: ValidEnrollmentApplication) =>
  createAction(A360EnrollmentApplicationActionType.SHOW_DUPLICATE_UPLOAD_ERROR, {application});

export const uploadApplication = (
  application: ValidEnrollmentApplication,
  enable_portals_virus_scan: boolean,
  accountNumber: string,
  conProfileNo: string,
  SIC_FileNet_Connectivity: boolean
) =>
  createAction(A360EnrollmentApplicationActionType.UPLOAD_APPLICATION, {
    application,
    enable_portals_virus_scan,
    accountNumber,
    conProfileNo,
    SIC_FileNet_Connectivity,
  });

export const clearApplication = () => createAction(A360EnrollmentApplicationActionType.CLEAR_APPLICATION);

export const changeEnrollmentFile = (enrollmentFile: File) =>
  createAction(A360EnrollmentApplicationActionType.CHANGE_ENROLLMENT_FILE, {enrollmentFile});

type FileNameConfig = {
  fileName: string;
  typeOfEnrollmentDataCd: string;
  _type: string;
};
export type CustomerConnectionProfile = {
  connectionProfileNumber: string;
  techPartnerName: string;
  fileNameConfiguration: FileNameConfig[];
};
export const CustomerConnectionEmptyProfile: CustomerConnectionProfile = {
  connectionProfileNumber: '',
  techPartnerName: '',
  fileNameConfiguration: [
    {
      fileName: '',
      typeOfEnrollmentDataCd: '',
      _type: ''
    }
  ]
}

type A360EnrollmentApplicationState = {
  application: EnrollmentApplication;
  customerConnectionProfile: Async<CustomerConnectionProfile[]>;
};

const DEFAULT_STATE: A360EnrollmentApplicationState = {
  application: EmptyEnrollmentApplication,
  customerConnectionProfile: new Empty()
};

type A360EnrollmentApplicationAction =
  | ReturnType<typeof changeCustomerConnectionProfile>
  | ReturnType<typeof showError>
  | ReturnType<typeof showDuplicateUploadError>
  | ReturnType<typeof changeEnrollmentFile>
  | ReturnType<typeof uploadApplication>
  | ReturnType<typeof clearApplication>;

export default (state: A360EnrollmentApplicationState = DEFAULT_STATE, action: A360EnrollmentApplicationAction): A360EnrollmentApplicationState => {
  switch (action.type) {
    case A360EnrollmentApplicationActionType.CHANGE_CUSTOMER_CONNECTION_PROFILE:
      return {
        ...state,
        customerConnectionProfile: action.payload.custConProfile
      };
    case A360EnrollmentApplicationActionType.SHOW_ERROR:
      return {
        ...state,
        application: new EnrollmentApplicationWithError(
          action.payload.application.file
        ),
      };
    case A360EnrollmentApplicationActionType.SHOW_DUPLICATE_UPLOAD_ERROR:
      return {
        ...state,
        application: new EnrollmentApplicationWithDuplicateUploadError(
          action.payload.application.file
        ),
      };
    case A360EnrollmentApplicationActionType.UPLOAD_APPLICATION:
      return {
        ...state,
        application: new SavingEnrollmentApplication(
          action.payload.application.file
        ),
      };
    case A360EnrollmentApplicationActionType.CLEAR_APPLICATION:
      return {
        ...state,
        application: EmptyEnrollmentApplication,
      };
    case A360EnrollmentApplicationActionType.CHANGE_ENROLLMENT_FILE:
      return {
        ...state,
        application: ValidEnrollmentApplication.create(
          action.payload.enrollmentFile
        ),
      };
    default:
      return state;
  }
};
